import api from "../../api.js";

export const listCompletedOrders = () => api.get("/frontshop/completed-orders");
